import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { getNetworkNameForApiCall } from 'framework-asset-preview-lib/internal/objectTypes/0-31/utils';
import cachedHttp from 'framework-asset-preview-lib/internal/shared/api/cachedHttp';
export function fetchAdCampaignBudget(adAccountId, adCampaignId) {
  return cachedHttp.get(`ads/v1/entity/manage/adwords/${adAccountId}/campaign/${adCampaignId}/budget`);
}
export function fetchAdCampaignTargeting(adAccountId, adCampaignId) {
  return cachedHttp.get(`ads/v1/entity/manage/adwords/${adAccountId}/campaign/${adCampaignId}/targeting`);
}
export function fetchAdAccounts() {
  return cachedHttp.get('ads/v1/ad-account/user-overview');
}
export function fetchAdCampaignDetails(crmObject) {
  const hsAdAccountId = getPropertyValue(crmObject, 'hs_ad_account_id');
  const hsAdCampaignId = getPropertyValue(crmObject, 'hs_ad_campaign_id');
  const network = getNetworkNameForApiCall(crmObject);
  const promises = [cachedHttp.get(`ads/v1/reports/${network}/account/${hsAdAccountId}/campaign/${hsAdCampaignId}/details`), fetchAdAccounts()];
  return Promise.all(promises).then(response => ({
    adCampaignDetails: response[0],
    adAccounts: response[1]
  }));
}